import {
  Button,
  Center,
  ConditionalRendering,
  Loader,
  Text
} from "@marketplace/ui";
import { getRouteApi } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { HiPlus } from "react-icons/hi";

import { NoSalesIllustraction } from "@/assets/images/no-sales-illustration";
import { Pagination, RouterLink } from "@/components";

import { DeleteSalesModal } from "../../components/delete-sales-modal";
import { SalesListFilters } from "../../components/sales-list-filters";
import { SalesListTable } from "../../components/sales-list-table";
import { useGetSalesListQuery } from "../../hooks/queries/use-get-sales-list-query";

const route = getRouteApi("/users/sales/");

const NoSales = () => {
  const { t } = useTranslation("users");

  return (
    <div className="flex flex-col justify-center items-center gap-y-6 mt-[56px]">
      <NoSalesIllustraction />
      <div className="text-center">
        <Text type="heading" size="xl" className="mb-2 text-fjord-grey-500">
          {t("salesListPage.emptySales.title")}
        </Text>
        <Text type="paragraph" size="l" className="text-fjord-grey-300">
          {t("salesListPage.emptySales.description")}
        </Text>
      </div>
      <Button variant="primary" rightSection={<HiPlus size={16} />}>
        {t("salesListPage.addSales")}
      </Button>
    </div>
  );
};

export const SalesListPage = () => {
  const { page, q, sort } = route.useSearch();
  const navigate = route.useNavigate();
  const { t } = useTranslation("users");

  const { data, isLoading } = useGetSalesListQuery({
    queryParams: {
      page,
      limit: 10,
      q,
      sort
    }
  });

  const salesListData = data?.data;
  const metadata = data?.metadata;

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <div>
          <Text type="heading" size="l" className="text-humble-blue-500">
            {t("salesListPage.title")}
          </Text>
          <Text className="text-fjord-grey-400">
            {t("salesListPage.subTitle")}
          </Text>
        </div>
        <RouterLink to="/users/sales/create">
          <Button variant="primary" rightSection={<HiPlus size={16} />}>
            {t("salesListPage.addSales")}
          </Button>
        </RouterLink>
      </div>

      <SalesListFilters />

      <ConditionalRendering
        condition={salesListData && salesListData!.length > 0}
      >
        <div className="space-y-6">
          <SalesListTable records={salesListData ?? []} />

          <Pagination
            currentPageTotal={salesListData?.length}
            totalData={metadata?.total}
            total={metadata?.totalPage ?? 0}
            value={metadata?.page}
            onChange={(value) =>
              navigate({
                search: {
                  page: value
                }
              })
            }
          />
        </div>
      </ConditionalRendering>

      <ConditionalRendering condition={isLoading}>
        <Center className="my-20">
          <Loader />
        </Center>
      </ConditionalRendering>

      <ConditionalRendering
        condition={salesListData && salesListData?.length === 0}
      >
        <NoSales />
      </ConditionalRendering>

      <DeleteSalesModal />
    </>
  );
};
